export default "__VITE_ASSET__f291d46f__"